<script setup lang="ts">
import type { UrlMetadata } from "../disko/api/urlMetadata.types";
import { LinkIcon } from "lucide-vue-next";
import { useMetadataDetails } from "../bookmark/useMetadataDetails";

const props = defineProps<{
  metadata: UrlMetadata;
}>();

const { faviconSrc } = useMetadataDetails(() => props.metadata);
</script>

<template>
  <div v-if="faviconSrc" class="relative">
    <img :src="faviconSrc" loading="lazy" referrerpolicy="no-referrer">
    <LinkIcon class="absolute -right-1 -bottom-1 size-3" aria-hidden="true" />
  </div>
  <LinkIcon v-else aria-hidden="true" />
</template>
